export default __webpack_public_path__ + "static/media/orochimaru.2cff6c2b.png";